type ApiResponse = {
	credits: number;
	credits_limit: number;
	title: string;
	validity: number;
};

type FormattedResponse = {
	credits: number;
	creditsLimit: number;
	title: string;
	validity: number;
};

class ActivePlansResponse {
	private data: ApiResponse[];

	constructor(data: ApiResponse[]) {
		this.data = data;
	}

	formatData(): FormattedResponse[] {
		return this.data.map((item) => ({
			credits: item.credits,
			creditsLimit: item.credits_limit,
			title: item.title,
			validity: item.validity,
		}));
	}
}

export default ActivePlansResponse;
